// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1FFmo","actions":"GroupTable_actions__2zICw","deleteModalFooter":"GroupTable_deleteModalFooter__2N4JI"};